<template>
  <div>
    <div class="search_area mt-4 col-12">
      <v-row cols="12" class="ma-0">
        <v-col cols="2" class="pb-0 pt-5 pl-0">
          검색 기간
        </v-col>
        <v-col cols="4" class="pl-0 pb-0">
          <v-menu v-model="startMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y>
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-model="search_from_date"
                readonly
                v-on="on"
                dense
                :style="{ height: '80%' }"
                class="d-inline-block mr-1 date-input"
              ></v-text-field>
            </template>
            <v-date-picker v-model="search_from_date" @input="startMenu = false" locale="ko" :max="search_to_date"></v-date-picker> </v-menu
          >~
          <v-menu v-model="endMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y>
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-model="search_to_date"
                readonly
                v-on="on"
                dense
                :style="{ height: '80%' }"
                class="d-inline-block mr-1 date-input"
              ></v-text-field>
            </template>
            <v-date-picker v-model="search_to_date" @input="endMenu = false" locale="ko" :min="search_from_date"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="2" class="pb-0 pt-5 pl-0">
          발송 구분
        </v-col>
        <v-col cols="4" class="pl-0 pb-0">
          <v-select
            v-model="send_type"
            :items="send_type_list"
            item-text="text"
            item-value="value"
            outlined
            dense
            :style="{ width: '100%' }"
            persistent-hint
            single-line
            class="pt-0"
            full-width
            hide-details
          ></v-select>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="2" class="pb-0 pt-5 pl-0">
          수신 핸드폰
        </v-col>
        <v-col cols="4" class="pl-0">
          <v-text-field
            v-model="receiver_phone"
            full-width
            placeholder="-없이 입력해주세요."
            outlined
            dense
            :style="{ width: '86%' }"
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="2" class="pb-0 pt-5 pl-0">
          수신 이메일
        </v-col>
        <v-col cols="4" class="pl-0">
          <v-text-field
            v-model="receiver_email"
            full-width
            placeholder="@포함 이메일 주소를 입력해주세요."
            outlined
            dense
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="text-center mt-5">
          <v-btn dark class="mr-3" width="100" large @click="getSendingHistoryList">조회</v-btn>
          <v-btn @click="initSearch" width="100" large>초기화</v-btn>
        </v-col>
      </v-row>
    </div>
    <div class="mt-5">
      <v-row>
        <v-col>
          <v-card outlined>
            <v-data-table
              :headers="headers"
              :items="sendingHistoryList"
              :server-items-length="send_list_total"
              :loading="tableLoading"
              :items-per-page="searchPayload.limit"
              hide-default-footer
              class="pa-2 elevation-1"
            >
              <template v-slot:[`item.content`]="{ item }">
                <v-hover v-slot:default="{ hover }">
                  <div
                    :class="['text-truncate', 'msg-text', { 'primary--text': hover }, { 'text-decoration-underline': hover }]"
                    @click="viewMessageDetail(item.id)"
                  >
                    {{ item.content }}
                  </div>
                </v-hover>
              </template>
              <template v-slot:[`item.receiver_id`]="{ item }">
                <div v-if="item.receiver_id">
                  <a :href="moveEcUserPage(item.receiver_id)" target="_blank">{{ item.receiver_id }}</a>
                </div>
                <div v-else>비회원</div>
              </template>
              <template slot="no-data">
                <div class="noDataProductInfos">내역이 없습니다.</div>
              </template>
            </v-data-table>
          </v-card>
          <template>
            <div class="text-xs-center mt-7">
              <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
          </template>
        </v-col>
      </v-row>
    </div>
    <SendResultDetail ref="sendResultDetail"></SendResultDetail>
  </div>
</template>

<style scoped>
.date-input {
  width: 128px;
}
</style>

<script>
import M from "@/libs/mapping.js";
import Filters from "@/libs/authservice/filters.js";
import SendResultDetail from "@/components/authservice/message/modal/SendResultDetail.vue";
import CommonMixin from "@/mixins/CommonMixin.js";
export default {
  data() {
    return {
      search_to_date: null,
      search_from_date: null,
      startMenu: false,
      endMenu: false,
      send_type: null,
      send_type_list: [
        { text: "전체", value: null },
        { text: "카카오톡", value: "kakao" },
        { text: "SMS", value: "sms" },
        { text: "이메일", value: "email" },
      ],
      result_type: null,
      result_type_list: [
        { text: "전체", value: null },
        { text: "성공", value: "success" },
        { text: "실패", value: "fail" },
      ],
      receiver_phone: null,
      receiver_email: null,
      sendingHistoryList: [],
      send_list_total: 0,
      pageCount: 0,
      headers: [
        {
          text: "No",
          align: "center",
          sortable: false,
          value: "no",
          width: "50px",
        },
        {
          text: "발송일시",
          align: "center",
          sortable: false,
          value: "send_date",
          width: "200px",
        },
        {
          text: "발송구분",
          align: "center",
          sortable: false,
          value: "send_type_text",
          width: "120px",
        },
        {
          text: "메시지",
          align: "center",
          sortable: false,
          value: "content",
        },
        {
          text: "회원정보",
          align: "center",
          sortable: false,
          value: "receiver_id",
          width: "150px",
        },
        {
          text: "수신자 정보",
          align: "center",
          sortable: false,
          value: "receiver_info",
          width: "200px",
        },
        {
          text: "발송건",
          align: "center",
          sortable: false,
          value: "result",
          width: "90px",
        },
        /*
        {
          text: "성공",
          align: "center",
          sortable: false,
          value: "result_success",
          width: "70px",
        },
        {
          text: "실패",
          align: "center",
          sortable: false,
          value: "result_fail",
          width: "70px",
        }
          */
      ],
      page: 1,
      tableLoading: false,
      searchPayload: {
        limit: 20,
        offset: 0,
      },
    };
  },
  mixins: [CommonMixin],
  created: function() {
    this.send_list_total = 0;
    this.initSearch();
  },
  watch: {
    page: {
      handler() {
        this.getSendingHistoryList();
      },
      deep: true,
    },
    send_list_total: function() {
      this.pageCount = Math.ceil(this.send_list_total / this.searchPayload.limit);
    },
  },
  methods: {
    viewMessageDetail: function(id) {
      this.$refs.sendResultDetail.openResultDetailModal(id);
    },
    getSendingHistoryList: async function() {
      const payload = {
        from: this.search_from_date,
        to: this.search_to_date,
        send_type: this.send_type,
        send_status: this.result_type,
        receiver_hp: this.receiver_phone,
        receiver_email: this.receiver_email,
        limit: this.searchPayload.limit,
        offset: (this.page - 1) * this.searchPayload.limit,
      };
      try {
        this.tableLoading = true;
        this.sendingHistoryList = [];
        const res = await M.api(M.entry("/get/message/send_history"), payload);
        console.log(payload, "get send_history", res);
        if (Object.prototype.hasOwnProperty.call(res, "send_list")) {
          this.send_list_total = res.count;
          res.send_list.forEach((item, index) => {
            item.no = this.send_list_total - (this.page - 1) * this.searchPayload.limit - index;
            this.sendingHistoryList.push(this.convertListData(item));
          });
        }
        this.tableLoading = false;
      } catch (error) {
        console.error("getSendingHistoryList error", error);
        this.tableLoading = false;
      }
    },
    convertListData: function(data) {
      data.content = this.$options.filters.msgTypeText(data.msg_type).replace(/<br\/>/g, " ");
      data.send_type_text = this.send_type_list.find((item) => item.value === data.send_type).text;
      if (data.send_status === "success") {
        data.result = 1;
        // data.result_success = 1;
        // data.result_fail = 0;
      } else {
        data.result = 1;
        // data.result_success = 0;
        // data.result_fail = 1;
      }
      return data;
    },
    initSearch() {
      let date = new Date();
      date.setMonth(date.getMonth() - 1);
      this.search_from_date = date.toISOString().substr(0, 10);
      this.search_to_date = new Date().toISOString().substr(0, 10);
      this.send_type = null;
      this.result_type = null;
      this.receiver_phone = null;
      this.receiver_email = null;
      this.getSendingHistoryList();
    },
  },
  filters: Filters,
  components: {
    SendResultDetail,
  },
};
</script>
